<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm8 md7>
        <v-card class="elevation-3">
          <v-container>
            <v-btn outlined color="primary" @click="$router.go(-1)">
              <v-icon left>west</v-icon> Voltar
            </v-btn>

            <v-toolbar
              color="white"
              text class="elevation-0">
              <v-toolbar-title
                class="headline">
                Detalhes do Perfil
              </v-toolbar-title>
            </v-toolbar>

            <div v-if="updateMsg" class="updateMsg">{{updateMsg}}</div>

            <v-card-text>
              <v-form ref="form" class="pl-6 pr-12">
                <v-layout row wrap>

                  <v-flex md4>
                    <div
                      class="subtitle-1 font-weight-light blue--text">
                      Nome
                    </div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      outlined
                      placeholder="Nome"
                      v-model="name"
                      :rules="nameRules"
                      dense
                      :maxlength="max"
                      counter="50"
                      color="teal accent-3">
                    </v-text-field>
                  </v-flex>

                  <v-flex md4>
                    <div class="subtitle-1 font-weight-light blue--text">
                      CPF
                    </div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      placeholder="CPF"
                      outlined
                      dense
                      v-mask="mask.cpf"
                      v-model="document"
                      :rules="documentRules"
                      color="teal accent-3">
                    </v-text-field>
                  </v-flex>

                  <v-flex md4>
                    <div class="subtitle-1 font-weight-light blue--text">Telefone</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      v-mask="mask.telephone"
                      v-model="telephone"
                      :rules="phoneRules"
                      dense
                      placeholder="Telefone"
                      outlined>
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="body-2 white--text"
                    @click="updateProfile"
                    color="primary"
                    depressed
                    :loading="loading">
                    Atualizar
                  </v-btn>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mask} from 'vue-the-mask';
export default {

  directives: {mask},
  data: () => ({
    loading:false,
    max: 50,
    apear: true,
    files: [],
    filesPreviews: [],
    mask: {
      telephone: '(##) #####-####',
      cpf: '###.###.###-##'
    },
    telephone: undefined,
    document: undefined,
    name: undefined,
    avatar: undefined,
    cargo: undefined,
    cargos: [
      'Administrador',
      'Tarm',
      'Medico Regulador',
    ],
    state: undefined,
    stateOptions: [
      'Acre (AC)',
      'Alagoas (AL)',
      'Amapá (AP)',
      'Amazonas (AM)',
      'Bahia (BA)',
      'Ceará (CE)',
      'Distrito Federal (DF)',
      'Espírito Santo (ES)',
      'Goiás (GO)',
      'Maranhão (MA)',
      'Mato Grosso (MT)',
      'Mato Grosso do Sul (MS)',
      'Minas Gerais (MG)',
      'Pará (PA)',
      'Paraíba (PB)',
      'Paraná (PR)',
      'Pernambuco (PE)',
      'Piauí (PI)',
      'Rio de Janeiro (RJ)',
      'Rio Grande do Norte (RN)',
      'Rio Grande do Sul (RS)',
      'Rondônia (RO)',
      'Roraima (RR)',
      'Santa Catarina (SC)',
      'São Paulo (SP)',
      'Sergipe (SE)',
      'Tocantins (TO)'
    ],
    email: undefined,
    password: undefined,
    confirmPassword: undefined,
    show_password: false,
    image: "",
    nameRules: [
      v=> !!v || 'Nome precisa ser preenchido!',
      v=> (v && /^[A-Za-zàáãäâèéëêìíïîòóõöôùúüûç ]+$/.test(v)) || 'Somente letras!'
    ],
    emailRules: [v => !!v || "Email precisa ser preenchido!"],
    documentRules: [v => !!v || "Documento precisa ser preenchido!"],
    phoneRules: [
      v => !!v || "Telefone precisa ser preenchido!",
      v => (v && /\(\d{2}\)\s\d{4,5}-?\d{4}/g.test(v)) || 'Telefone Inválido!',
    ],
    updateMsg: undefined,
    passwordRules: [/* v => !!v || "Senha precisa ser preenchido!" */],
  }),

  created () {

    let userObj = this.$store.getters.user
    this.initData(userObj)
    //console.log(userObj);
  },

  computed: {

    formIsValid() {
      return this.name && this.email && this.password && this.cargo && this.state && this.telephone && this.document
    },

    confirmPasswordRules(){
      if(this.password && !this.confirmPassword)
        return "Confirmar senha precisa ser preenchido!"
      if(this.password && this.confirmPassword && this.confirmPassword != this.password)
        return 'As senhas são diferentes!'
      return null
    },

    user(){
      return this.$store.getters.user
    }
  },
  watch:{
    //
  },
  methods: {

    initData(user){
      //console.log(user)
      this.name = user.name;
      this.email = user.email;
      this.telephone = user.phone;
      this.document = user.document;
    },

    handleFileUpload() {
      let uploadedFiles = this.$refs.files.files;
      for (let i = 0; i < uploadedFiles.length; i++) {
        if (this.files.indexOf(uploadedFiles[i]) < 0) {
          let index = this.files.push(uploadedFiles[i]);
          this.readFileUrl(uploadedFiles[i], index - 1);
          this.apear = false
        }
      }
      this.apear = false
    },

    readFileUrl(file, index) {
      let self = this;
      let reader = new FileReader();
      reader.onload = function(e) {
        self.filesPreviews[index] = e.target.result;
        self.$forceUpdate();
      };
      reader.readAsDataURL(file);
    },

    removeFile() {
      this.files = [];
      this.filesPreviews = [];
      this.apear = true;
    },

    async updateProfile(){
      if (this.$refs.form.validate()) {
        let updated = {
          name: this.name,
          phone: this.telephone,
          document: this.document,
        };
        this.loading = true;
        let alterou = await this.$store.dispatch('updateProfile', updated )
          .then( response => {
            this.loading = false;
            if (response.status) {
              this.setUpdateMsg("Dados atualizados");
              return true;
            }
            else{
              return false;
            }
          })
          .catch( error => {
            this.loading = false;
            return false;
          });
        location.reload();
      }
    },

    setUpdateMsg (mensagem) {
      this.updateMsg = mensagem;
      setTimeout(() => {
        this.updateMsg = undefined;
      }, 5000);
    },
  }
}
</script>

<style scoped>
.updateMsg{
  background-color: yellow;
  color: red;
  text-align-last: center;}
</style>
